<template>
  <div class="xs12 sm12 md12 lg12">
    <div class="d-flex justify-end" v-if="!createMode">
      <div class="pr-2 mr-auto">{{ node.meta.question }}</div>
      <div v-if="editMode">{{ node.meta.comment }}</div>
      <div v-if="!editMode">{{ displayValue }}</div>

      <span v-if="editMode">
        <v-radio-group
          class="pt-0 mt-0"
          :disabled="valueIsEmpty"
          :label="node.name"
          :value="valueIsEmpty ? null : node.value[editIndex].val[0]"
          @change="changeValue($event, node)"
          :hint="
            valueIsEmpty
              ? 'This field is disabled until you select a date/time below'
              : null
          "
          persistent-hint
        >
          <v-radio name="active" label="No" :value="'No'"></v-radio>
          <v-radio name="active" label="Yes" :value="'Yes'"></v-radio>
        </v-radio-group>
      </span>
    </div>
    <v-form ref="form" v-else class="full-width">
      <div class="d-flex justify-space-between full-width">
        <v-text-field
          label="Question (optional)"
          v-model="node.meta.question"
          class="mr-4"
        ></v-text-field>
      </div>
      <div class="d-flex justify-space-between full-width">
        <v-text-field
          label="Tooltip (optional)"
          v-model="node.meta.tooltip"
          class="mr-4"
        ></v-text-field>
      </div>
    </v-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import isArray from "lodash/isArray";

export default {
  name: "Boolean",
  props: {
    node: Object,
    editMode: Boolean,
    editIndex: Number,
    createMode: { type: Boolean, default: false, required: false },
    selectedRecord: Object,
    isRoot: Boolean,
  },
  mounted() {
    this.$emit("validation", true);
  },
  data: () => ({}),
  methods: {
    changeValue(e, node) {
      if (!e) {
        return;
      }
      node.value[this.editIndex].val[0] = e;
      node.value[this.editIndex].authorName = this.getName;
      node.value[this.editIndex].authorId = this.loginDetails.id;
      this.$emit("updateconditionalnodes");
      this.$root.$emit("edit:update");
    },
  },
  computed: {
    ...mapGetters({
      loginDetails: "getUser",
      getName: "getLoggedInName",
    }),

    displayValue: function() {
      if (this.node.value.length) {
        const latest = this.node.value[this.node.value.length - 1];
        return isArray(latest.val) ? latest.val[0] : latest.val;
      } else return "";
    },
    valueIsEmpty: function() {
      return this.node.value.length === 0;
    },
  },
};
</script>
